export default "<app-blue-header >\n   \n  \n  </app-blue-header>\n\n<h1>No menu assigned, please contact Admin</h1>\n"